// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__166k6","col":"styles_col__m-0Uj"};